import React, { useContext, useState } from 'react'
import { MyShipments } from '../../components/dashboard/myShipments'
import { BoughtProducts } from '../../components/dashboard/boughtProducts'
import { MyBooks } from '../../components/dashboard/myBooks'

export default function MyBooksPage() {

  return (
    <div className="h-full relative flex flex-col gap-5">
      <MyBooks />
    </div>
  )
}